import React from 'react';
export const Story = () => {
  return <section className="mb-10" data-id="element-178">
      <p className="text-2xl mb-6" data-id="element-179">
        "I was wrong. Dead wrong about how we've been treating canine anxiety."
      </p>
      <p className="text-xl mb-4" data-id="element-180">
        What changed her mind wasn't a new study or medical breakthrough. It was
        watching her own rescue dog, Bailey, suffer through months of side
        effects from the very medications she'd been confidently prescribing to
        her patients.
      </p>
      <p className="text-xl mb-4" data-id="element-181">
        "I saw the lethargy, the personality changes, the digestive issues," Dr.
        Chen admits. "But the final straw was when Bailey looked at me with
        those glazed, medicated eyes and I realized... this isn't healing. This
        is just masking."
      </p>
      <div className="w-full h-[200px] bg-gray-200 mb-6 overflow-hidden" data-id="element-182">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/v892gPR9zAMi3e4SwEVWsX/GettyImages-1193325318_crop.jpg" alt="Dog with torn paper showing anxiety behaviors" className="w-full h-full object-cover" data-id="element-183" />
      </div>
      <p className="text-xl mb-6" data-id="element-184">
        That moment led Dr. Chen down a path that would completely transform her
        practice - and potentially save your dog from unnecessary medication.
      </p>
      <p className="text-xl font-bold mb-4" data-id="element-185">
        What she discovered will challenge everything you think you know about
        treating dog anxiety. And if you're considering medication for your
        anxious pup - or already using it - what you're about to read could
        change your dog's life.
      </p>
      <h2 className="text-4xl font-bold text-gray-800 mb-4" data-id="element-186">
        Dr. Chen's Shocking Confession
      </h2>
      <p className="text-xl mb-4 italic" data-id="element-187">
        "For years, I did what I was trained to do. Anxious dog comes in -
        prescribe Prozac, Xanax, or Trazodone. It seemed logical. These drugs
        work for humans, they should work for dogs, right?
      </p>
      <p className="text-xl mb-4 italic" data-id="element-188">
        I never questioned it until Bailey came into my life.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-189">
        Bailey was a 3-year-old German Shepherd mix I rescued from a high-kill
        shelter. Sweet as pie, but absolutely terrified of everything -
        thunderstorms, fireworks, even the vacuum cleaner. Classic anxiety case.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-190">
        Following my own protocol, I put him on Fluoxetine. Standard dosage,
        carefully monitored. Within weeks, yes, he was calmer during storms.
        Mission accomplished, I thought.
      </p>
      <p className="text-xl mb-4 italic" data-id="element-191">But something was wrong.</p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-192">
        The Side Effects I'd Been Ignoring:
      </h3>
      <ul className="list-disc pl-6 mb-6 text-xl" data-id="element-193">
        <li className="mb-1" data-id="element-194">
          Bailey stopped playing fetch (his favorite thing)
        </li>
        <li className="mb-1" data-id="element-195">He slept 14+ hours a day</li>
        <li className="mb-1" data-id="element-196">His appetite disappeared</li>
        <li className="mb-1" data-id="element-197">Those bright, intelligent eyes became... dull</li>
        <li className="mb-1" data-id="element-198">He gained weight and became lethargic</li>
        <li className="mb-1 font-bold" data-id="element-199">
          Worst of all: he stopped being Bailey
        </li>
      </ul>
      <p className="text-xl mb-4 italic" data-id="element-200">
        I realized I'd been so focused on stopping the anxiety symptoms that I'd
        completely overlooked what these medications were doing to the dogs'
        quality of life.
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-201">
        The Heartbreaking Question:
      </h3>
      <p className="text-xl mb-6 italic" data-id="element-202">
        One evening, Bailey looked up at me with those medicated, glassy eyes,
        and I asked myself: 'Would I want to live like this? Calm but... empty?'
      </p>
      <p className="text-xl mb-4 italic" data-id="element-203">That's when everything changed."</p>
    </section>;
};